import { ValidationErrors } from 'final-form';

import { validateCronExpressionOfTask } from './cronExpression';
import { WebexCallingConfigurationType } from '../../scene/integrations/types';

/**
 * Validations for fields that can be statically validated should be placed directly in `Field` component
 * or `useField` hook.
 *
 * This form validation should serve for applying dynamic validators that relies on another fields.
 * Used validator are determined after changes on fields in order to avoid generating some random `key`
 * ([docs](https://final-form.org/docs/react-final-form/types/FieldProps#validate)) to trigger field level validation.
 */
export const validateWXCallingForm = (values: WebexCallingConfigurationType): ValidationErrors => ({
  tasks: [
    {
      // user sync
      cronExpression: validateCronExpressionOfTask(values.tasks[0]),
    },
  ],
});
